/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { configure as configureNotification, close as closeNotification } from "redux/actions/Notifications";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

function Page({children, ...props}) {

    const dispatch = useDispatch();

    const {configured, ...notification} = useSelector(state => state.Notifications);    

    function onCloseNotification(e, reason) {
        if (reason === "clickaway") {
            return;
        }
        dispatch(closeNotification());
    }

    const initialNotification = {
        open: false,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        autoHideDuration: 4000,
        severity: "success",
        message: ""
    };

    useEffect(()=> {
        if(!configured){
            dispatch(configureNotification(initialNotification));
        }
    }, [configured]);

    return (
        <div {...props}>
            {children}
            {configured && (
                <Snackbar {...notification} onClose={onCloseNotification}>
                    <Alert elevation={6} variant="filled" severity={notification.severity} onClose={onCloseNotification}>
                        {notification.message}
                    </Alert>
                </Snackbar>
            )}
        </div>
    );
}

export default Page;
